import React, { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Truck } from 'lucide-react';
import { Button } from './ui/button';

const PublicHeader = memo(({ title = 'Fahrzeugdetails', showBackButton = true }) => {
  const navigate = useNavigate();

  return (
    <header className="bg-[#1a1a1a] border-b border-[#2C3E50] py-4">
      <div className="container mx-auto px-4 flex items-center gap-4">
        {showBackButton && (
          <Button
            variant="outline"
            onClick={() => navigate('/')}
            className="border-[#FDB913] text-[#FDB913] hover:bg-[#FDB913] hover:text-[#1a1a1a]"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Zurück
          </Button>
        )}
        <div className="flex items-center gap-3 text-white">
          <Truck className="h-8 w-8" />
          <div>
            <h1 className="text-xl font-bold">Hogir Acar</h1>
            <p className="text-xs text-gray-300">{title}</p>
          </div>
        </div>
      </div>
    </header>
  );
});

PublicHeader.displayName = 'PublicHeader';

export default PublicHeader;
